'use client';
import React, { forwardRef } from 'react';
import LineTab from './LineTab.mjs';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

/**
 * 탭 갯수 제한없이 사용 가능한 페이지 단위의 탭
 *
 * ### Features
 * - 메인 탭의 글자크기 : 18px
 * - width가 화면을 벗어나면 horizontal scroll 발생
 */
const LineTabFlexibleMain = /*#__PURE__*/forwardRef((props, ref) => {
  useApplyLogging('LineTabFlexibleMain');
  return /*#__PURE__*/React.createElement(LineTab, {
    ...props,
    typeLayout: "flexible",
    type: "main",
    ref: ref
  });
});
LineTabFlexibleMain.displayName = 'LineTabFlexibleMain';

export { LineTabFlexibleMain as default };
